import { areDatesNotEqual, areNotEqual, isDateEmpty, isDropdownEmpty, isNumberEmpty, isYnDropdownEmpty } from "@/common/validation-checkers";
import IRetreat from "@/models/retreats/iretreat";

export function RetreatHasRequiredFormFields(retreat: IRetreat){

    if (!retreat) {
        return false;
    }

    if (
        !isDateEmpty(retreat.startDate) &&
        !isDateEmpty(retreat.endDate) &&
        !isDropdownEmpty(retreat.venueId) &&
        !isDropdownEmpty(retreat.seasonId) &&
        !isYnDropdownEmpty(retreat.isGroupBooking) &&
            (retreat.isGroupBooking === false ||
            (retreat.isGroupBooking === true && !isNumberEmpty(retreat.occupancy) && !isYnDropdownEmpty(retreat.manageRooming) && !isNumberEmpty(retreat.retailPrice)))
    ) {
        return true;
    }

    return false;
}

export function RetreatHasFormData(retreat: IRetreat){

    if (!retreat) {
        return false;
    }

    if (
        isDateEmpty(retreat.startDate) &&
        isDateEmpty(retreat.endDate) &&
        isDropdownEmpty(retreat.venueId) &&
        isDropdownEmpty(retreat.instructorId) &&
        isDropdownEmpty(retreat.statusId) &&
        isDropdownEmpty(retreat.seasonId) &&
        isYnDropdownEmpty(retreat.isGroupBooking) &&
        isNumberEmpty(retreat.retailPrice)
    ) {
        return false;
    }
    else {
        return true;
    }
}

export function RetreatHasChanged(original: IRetreat, revised: IRetreat) {

    if (!original || !revised) {
        return false;
    }

    if (
        areDatesNotEqual(original.startDate, revised.startDate) ||
        areDatesNotEqual(original.endDate, revised.endDate) ||
        areNotEqual(original.seasonId, revised.seasonId) ||
        areNotEqual(original.instructorId, revised.instructorId) ||
        areNotEqual(original.venueId, revised.venueId) ||
        areNotEqual(original.statusId, revised.statusId) ||
        areNotEqual(original.isGroupBooking, revised.isGroupBooking) ||
        areNotEqual(original.manageRooming, revised.manageRooming) ||
        areNotEqual(original.occupancy, revised.occupancy) ||
        areNotEqual(original.retailPrice, revised.retailPrice) ||
        areNotEqual(original.retreatCostTypeId, revised.retreatCostTypeId) 
    ) {
        return true;
    }
    else {
        return false;
    }
}